import EventBus from '../../../shared/js/wirebox/event-bus'
import '../../../shared/js/wirebox/modules/storage'
import jQuery from 'jquery'

class CookieBar {
    
    /**
     * Construct component
     * @param container
    */
    constructor(container) {
        
        /**
         * Container jQuery object
         * @type {object}
        */
        this.container = container
        
        /**
         * Key for usage in local storage
         * @type {boolean}
        */
        this.key = 'accepted-cookies'
        
        /**
         * Unix timestamp for cookies accepted time
         * @type {intefer}
        */
        this.timestamp = 0
        
        this.setTimestamp()
        this.bindEvents()
        
    }
    
    /**
     * Run component
    */
    run() {
        EventBus.publish('storage.read', {
            callback: this.storageChecked.bind(this),
            key: this.key
        })
    }
    
    /**
     * Set timestamp
    */
    setTimestamp() {
        let date = new Date()
        this.timestamp = Math.floor(date / 1000)
    }
    
    /**
     * Local storage has been checked
     * @param value
    */
    storageChecked(value) {
        
        //Do nothing if a value is stored and the time is within the past year
        if (value && value > this.timestamp - (60 * 60 * 24 * 365)) {
            
            //Apply cookie acceptance
            this.applyCookieAcceptance()
            
            return
            
        }
        
        //Show cookie bar
        this.container.show()
        
        //Add pending class to html tag
        jQuery('html').addClass('cookies-pending')
        
    }
    
    /**
     * Cookies have been accepted
    */
    cookiesAccepted() {
        
        //Hide cookie bar
        this.container.hide().trigger('hidden')
        
        //Store accepted time in local storage
        EventBus.publish('storage.write', {
            key: this.key,
            value: this.timestamp
        })
        
        //Remove height from cookie bar's anchor
        jQuery('#cookie-bar-anchor').height('')
        
        //Apply cookie acceptance
        this.applyCookieAcceptance()
        
    }
    
    /**
     * Apply cookie acceptance
    */
    applyCookieAcceptance() {
        
        //Add cookies accepted class to html tag and remove pending class
        jQuery('html').addClass('cookies-accepted').removeClass('cookies-pending')
        
        //Broadcast cookie acceptance
        EventBus.publish('cookies.accepted')
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Run module
        EventBus.subscribe('modules-initialised', this.run.bind(this))
        
        //Accept cookies button click
        jQuery('#accept-cookies').click(this.cookiesAccepted.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let container = jQuery('#cookie-bar')
    
    if (container.length > 0) {
        new CookieBar(container)
    }
    
})

export default CookieBar